import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Events } from 'ionic-angular';
import { WhiskyDB } from '../../data/db';

@Component({
  selector: 'page-newDistillery',
  templateUrl: 'newDistillery.html'
})

export class NewDistilleryPage {

  allItems: string[];
  newName: string = "";
  newRegion: string = "";
  autocomplete: string = "";
  selectedRegion: string = "";
  hide: boolean =  true;

  constructor(public navCtrl: NavController, public events: Events) {
    console.log("Found "  + WhiskyDB.regions.length + " regions");
    this.allItems = WhiskyDB.regions;
  }

  compareFn(e1: string, e2: string): boolean {
    //console.log("compare " + e1 + " " + e2);
    return e1 === e2;
  }
  

  regionChange()
  {
    console.log("Region change");
    if(this.selectedRegion === "(new)")
    {
      this.hide = false;
    } else {
      this.hide = true;
    }
  }

  saveDistillery(event) {
    console.log("Save distilleries: " + this.newName);

      if(this.newName.length > 0)
      {
        console.log("Sending distilleries:add event");
        if(this.newRegion == null || this.newRegion === "")
          this.events.publish("distilleries:add", this.newName, this.selectedRegion);
        else
          this.events.publish("distilleries:add", this.newName, this.newRegion);
      }
  }
}




// WEBPACK FOOTER //
// ./src/pages/newDistillery/newDistillery.ts